import getValidationPattern from "./getValidationPattern";

const validateValue = (value, validateAs) => {
  const pattern = getValidationPattern(validateAs)
  if (!pattern) return false
  const notUndefinedPattern = getValidationPattern('notUndefined')
  return (pattern.test(value) && notUndefinedPattern.test(value))
}

export default validateValue